import { z } from 'zod'
import { firestoreTimestamp, firestoreWriteTimestamp } from '../shared/schema'

export const schema = z.object({
  productId: z.string(),
  creatorUserId: z.string(),
  expiresAt: firestoreTimestamp,
  organizationId: z.string(),
  productName: z.string(),
  productType: z.string(),
  sectionPassQuantity: z.number().int(),
  sectionPassPrice: z.number().int(),
  updatedAt: firestoreTimestamp,
})

export const writeSchema = schema.extend({
  expiresAt: firestoreWriteTimestamp,
  updatedAt: firestoreWriteTimestamp,
})

export const empty = Object.freeze(
  schema.parse({
    productId: '',
    expiresAt: { seconds: 0, nanoseconds: 0 },
    creatorUserId: '',
    organizationId: '',
    productName: '',
    productType: '',
    sectionPassQuantity: 0,
    sectionPassPrice: 0,
    updatedAt: { seconds: 0, nanoseconds: 0 },
  })
)

export type FirestoreOrganizationCustomProduct = z.infer<typeof schema>
export type FirestoreOrganizationCustomProductWrite = z.infer<
  typeof writeSchema
>
